// hooks/useAccountBalance.js
import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { conf } from '../../../confg';

/**
 * Custom hook for managing user account balance calculations
 */
export const useAccountBalance = (cartTotal, gold, isTeammate) => {
  const [balance, setBalance] = useState({
    pool: 0,
    gram: 0,
    mandeHesabPrice: 0,
    creditor: 0,
    beyane: cartTotal < 50000000 ? 30000000 : 50000000,
  });

  const [loading, setLoading] = useState(false);

  const calculateBalance = useCallback(async () => {
    const token = localStorage.getItem('token');
    if (!token || token === 'undefined' || token === 'null' || !token.trim()) return;

    setLoading(true);
    try {
      const response = await axios({
        url: conf.server_url + 'mandeHesab',
        method: 'GET',
        timeout: 0,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: `Bearer ${token}`,
        },
      });

      const pool = response.data.pool || 0;
      const gram = response.data.geram || 0;
      const beyane = cartTotal < 50000000 ? 30000000 : 50000000;

      // Calculate balance based on user type
      const hesab = pool;

      let mandeHesabPrice = 0;
      let creditor = 0;

      if (isTeammate === 1) {
        if (hesab > 0) {
          if (hesab <= beyane) {
            mandeHesabPrice = beyane - hesab;
          } else {
            creditor = hesab - beyane;
          }
        }
        if (hesab < 0) {
          mandeHesabPrice = beyane - hesab;
        }
      } else {
        if (hesab > 0) {
          if (cartTotal * 10 >= hesab) {
            mandeHesabPrice = cartTotal * 10 - hesab;
          } else {
            creditor = hesab - cartTotal * 10;
          }
        }
        if (hesab < 0) {
          mandeHesabPrice = cartTotal * 10 - hesab;
        }
      }

      setBalance({
        pool,
        gram,
        mandeHesabPrice,
        creditor,
        beyane,
      });
    } catch (error) {
      console.error('Error calculating account balance:', error);
    } finally {
      setLoading(false);
    }
  }, [cartTotal, gold, isTeammate]);

  useEffect(() => {
    calculateBalance();
  }, [calculateBalance]);

  useEffect(() => {
    setBalance((prev) => ({
      ...prev,
      beyane: cartTotal < 50000000 ? 30000000 : 50000000,
    }));
  }, [cartTotal]);

  return {
    balance,
    loading,
    calculateBalance,
  };
};
